import Signal from 'signals';

class SignalMap {

	constructor() {
		this.subnavigationShown = new Signal();
		this.subnavigationHidden = new Signal();
		this.mobileMenuOpened = new Signal();
		this.mobileMenuClosed = new Signal();
	}
}

export default SignalMap;


// WEBPACK FOOTER //
// ./js/SignalMap.js